module.exports = __webpack_public_path__ + "static/media/JDB_Transparency.9deb8760.png";